import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { setGlobalLocale } from '../../utils/dateUtils';

const DateLocalizationController = () => {
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    setGlobalLocale(language);
  }, [language]);

  return null;
};

export default DateLocalizationController;
